'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'icons';
var width = 512;
var height = 512;
var aliases = ["heart-music-camera-bolt"];
var unicode = 'f86d';
var svgPathData = 'M73.3 0c19.5 0 38.5 7.7 52.3 21.5L128 24l2.5-2.5C144.3 7.7 163.2 0 182.7 0C222.8 0 256 32.5 256 72.6c0 20.1-8.3 39.2-22.9 52.9L128 224 22.9 125.5C8.3 111.8 0 92.6 0 72.6C0 32.5 33.2 0 73.3 0zM211.2 102.2c8.2-7.7 12.8-18.4 12.8-29.6c0-22-18.5-40.6-41.3-40.6c-11.1 0-22 4.5-29.7 12.2l-2.5 2.5L128 69.3 105.4 46.6l-2.5-2.5 20.7-20.7L102.9 44.2C95.2 36.5 84.4 32 73.3 32C50.5 32 32 50.6 32 72.6c0 11.2 4.6 21.9 12.8 29.6l83.2 78 83.2-78zM512 4.5L512 24l0 144-.2 0c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-83.4L352 69.1 352 200l-.2 0c.1 1.3 .2 2.7 .2 4c0 28.7-28.7 52-64 52s-64-23.3-64-52s28.7-52 64-52c11.7 0 22.6 2.5 32 7l0-103 0-13.1 12.9-2.6 160-32L512 4.5zM480 172c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM320 204c0-3.1-1.5-7.5-6.9-11.9c-5.5-4.5-14.3-8.1-25.1-8.1s-19.5 3.6-25.1 8.1c-5.5 4.4-6.9 8.8-6.9 11.9s1.5 7.5 6.9 11.9c5.5 4.5 14.3 8.1 25.1 8.1s19.5-3.6 25.1-8.1c5.5-4.4 6.9-8.8 6.9-11.9zM200 256l16 32 40 0 32 0 0 32 0 160 0 32-32 0L32 512 0 512l0-32L0 320l0-32 32 0 40 0 16-32 112 0zm16 64l-19.8 0-8.8-17.7L180.2 288l-72.4 0-7.2 14.3L91.8 320 72 320l-40 0 0 160 224 0 0-160-40 0zm-72 40a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0 96a64 64 0 1 1 0-128 64 64 0 1 1 0 128zM452.3 261.1l23.4 21.8-79 85.1 75.3 0 36.7 0-25 26.9-104 112-23.4-21.8 79-85.1L360 400l-36.7 0 25-26.9 104-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faIcons = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;